module.exports = __webpack_public_path__ + "img/map3.5864a536.jpg";